import styled from '../styled-components';
export var BaseButton =
/*#__PURE__*/
styled.button.withConfig({
  displayName: "Button__BaseButton",
  componentId: "sc-1opgu7-0"
})(["outline:none;border:0;-webkit-appearance:none;padding:0 20px;height:40px;font-family:'Lato',sans-serif;font-size:12px;letter-spacing:1.5px;text-transform:uppercase;display:flex;align-items:center;justify-content:center;border-radius:3px;box-shadow:0 1px 3px 0 rgba(0,0,0,0.15);cursor:pointer;&::-moz-focus-inner{border:0;}&:active{box-shadow:0 1px 1px 0 rgba(0,0,0,0.15);}&:disabled{color:#bfbfbf;border:1px solid rgba(0,0,0,0);cursor:default;background-color:#f4f4f4 !important;}"]);
export var Button =
/*#__PURE__*/
styled(BaseButton).withConfig({
  displayName: "Button",
  componentId: "sc-1opgu7-1"
})(["background-color:", ";border:1px solid ", ";color:", ";&:focus{border:1px solid rgba(39,103,149,1);}&:hover{background-color:#3889c5;}&:active{background-color:#3780b5;}"], function (props) {
  return props.theme.color.primary.lightBlue;
}, function (props) {
  return props.theme.color.primary.lightBlue;
}, function (props) {
  return props.theme.color.text.white;
});
export var SecondaryButton =
/*#__PURE__*/
styled(BaseButton).withConfig({
  displayName: "Button__SecondaryButton",
  componentId: "sc-1opgu7-2"
})(["background-color:", ";color:", ";border:1px solid ", ";box-shadow:0 1px 3px 0 rgba(0,0,0,0.07);&:focus{border:1px solid rgba(57,148,214,0.5);}&:hover{background-color:#f9fbfd;}&:active{border:1px solid #ededed;background-color:#ebf4fa;}"], function (props) {
  return props.theme.color.text.white;
}, function (props) {
  return props.theme.color.primary.lightBlue;
}, function (props) {
  return props.theme.color.grey.light;
});
export var BoxButton =
/*#__PURE__*/
styled(BaseButton).withConfig({
  displayName: "Button__BoxButton",
  componentId: "sc-1opgu7-3"
})(["border:2px solid ", ";color:", ";font-weight:bold;border-radius:0;box-shadow:none;&:focus{box-shadow:inset 0 0 1px 1px ", ";}&:hover{background-color:#f9fbfd;}&:active{background-color:#ebf4fa;}"], function (props) {
  return props.theme.color.primary.darkBlue;
}, function (props) {
  return props.theme.color.primary.darkBlue;
}, function (props) {
  return props.theme.color.primary.lightBlue;
});
export var DangerButton =
/*#__PURE__*/
styled(BaseButton).withConfig({
  displayName: "Button__DangerButton",
  componentId: "sc-1opgu7-4"
})(["background-color:", ";border:1px solid ", ";color:", ";&:focus{border:1px solid #a83027;}&:hover{background-color:#de4337;}&:active{background-color:#cb4236;}"], function (props) {
  return props.theme.color.primary.red;
}, function (props) {
  return props.theme.color.primary.red;
}, function (props) {
  return props.theme.color.text.white;
});
export var SuccessButton =
/*#__PURE__*/
styled(BaseButton).withConfig({
  displayName: "Button__SuccessButton",
  componentId: "sc-1opgu7-5"
})(["background-color:", ";border:1px solid ", ";color:", ";&:focus{border:1px solid #3e7400;}&:hover{background-color:#559a05;}&:active{background-color:#528f0a;}"], function (props) {
  return props.theme.color.primary.armyGreen;
}, function (props) {
  return props.theme.color.primary.armyGreen;
}, function (props) {
  return props.theme.color.text.white;
});
export var LinkButton =
/*#__PURE__*/
styled(BaseButton).withConfig({
  displayName: "Button__LinkButton",
  componentId: "sc-1opgu7-6"
})(["background-color:#ffffff;border:0;color:", ";padding:0 10px;letter-spacing:normal;text-transform:none;font-size:14px;font-weight:normal;box-shadow:none;&:hover,&:active,&:focus{background:#f9f9f9;}"], function (props) {
  return props.theme.color.primary.lightBlue;
});
export var DangerLinkButton =
/*#__PURE__*/
styled(LinkButton).withConfig({
  displayName: "Button__DangerLinkButton",
  componentId: "sc-1opgu7-7"
})(["color:", ";"], function (props) {
  return props.theme.color.primary.red;
});